<template>
  <footer class="ct-footer footer-dark">
    <!-- Top Footer -->
    <div class="container">
      <div class="footer-top">
        <div class="footer-logo">
          <footer-logo/>
        </div>
        <div class="footer-widget pb-0">
          <ul class="social-media">
            <li v-if="config.socialMedia && config.socialMedia.facebook">
              <a :href="config.socialMedia.facebook"
                 target="_blank"
                 class="facebook">
                <i class="fab fa-facebook-f"></i>
              </a>
            </li>
            <li v-if="config.socialMedia && config.socialMedia.instagram">
              <a :href="config.socialMedia.instagram"
                 class="instagram">
                <i class="fab fa-instagram"></i>
              </a>
            </li>
            <li v-if="config.socialMedia && config.socialMedia.youtube">
              <a :href="config.socialMedia.youtube"
                 class="youtube">
                <i class="fab fa-youtube"></i>
              </a></li>
            <li v-if="config.socialMedia && config.socialMedia.twitter">
              <a :href="config.socialMedia.facebook"
                 class="twitter">
                <i class="fab fa-twitter"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!--    &lt;!&ndash; Middle Footer &ndash;&gt;-->
    <div class="footer-middle">
      <div class="container">
        <div class="row">
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 footer-widget">
            <h5 class="widget-title">{{ $t('Main menu') }}</h5>
            <ul>
              <li v-for="menuItem in menu" :key="menuItem.url">
                <router-link :to="menuItem.url">
                  {{ menuItem.title }}
                </router-link>
              </li>
            </ul>
          </div>
          <!--          {#-->
          <!--          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 footer-widget">-->
          <!--            <h5 class="widget-title">Information</h5>-->
          <!--            <ul>-->
          <!--              <li><a href="index.html">Home</a></li>-->
          <!--              <li><a href="blog-grid.html">Blog</a></li>-->
          <!--              <li><a href="about-us.html">About Us</a></li>-->
          <!--              <li><a href="menu-v1.html">Menu</a></li>-->
          <!--              <li><a href="contact-us.html">Contact Us</a></li>-->
          <!--            </ul>-->
          <!--          </div>-->
          <!--          #}-->
          <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 footer-widget">
            <h5 class="widget-title">{{ $t('Your restaurant') }}</h5>
            <p>
              <span><strong>{{ config.restaurants[0].name }}</strong></span><br/>
              <span>{{ config.restaurants[0].address }}</span><br/>
              <span>{{ config.restaurants[0].zip }} {{ config.restaurants[0].city }}</span><br/>
              <span>
                          <phone-number :number="config.restaurants[0].phoneNumber" :show-icon="true"></phone-number>
                                  </span>
            </p>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 footer-widget">
            <h5 class="widget-title">{{ $t('Opening Hours') }}</h5>
            <p>
                          <span>
                            <span>
                              {{ $t('Monday') }}:
                            </span>
                            {{ config.restaurants[0].openingHours.monday.hours[0] }}
                          </span>
              <br/>
              <span>
                            <span>
                              {{ $t('Tuesday') }}:
                            </span>
                            {{ config.restaurants[0].openingHours.tuesday.hours[0] }}
                          </span>
              <br/>
              <span>
                            <span>
                              {{ $t('Wednesday') }}:
                            </span>
                            {{ config.restaurants[0].openingHours.wednesday.hours[0] }}
                          </span>
              <br/>
              <span>
                            <span>
                              {{ $t('Thursday') }}:
                            </span>
                            {{ config.restaurants[0].openingHours.thursday.hours[0] }}
                          </span>
              <br/>
              <span>
                            <span>
                              {{ $t('Friday') }}:
                            </span>
                            {{ config.restaurants[0].openingHours.friday.hours[0] }}
                          </span>
              <br/>
              <span>
                            <span>
                              {{ $t('Saturday') }}:
                            </span>
                            {{ config.restaurants[0].openingHours.saturday.hours[0] }}
                          </span>
              <br/>
              <span>
                            <span>
                              {{ $t('Sunday') }}:
                            </span>
                            {{ config.restaurants[0].openingHours.sunday.hours[0] }}
                          </span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <corporate-footer/>
  </footer>
</template>
<script>
import CorporateFooter from "@/views/BottomBar/CorporateFooter";
import FooterLogo from "@/views/BottomBar/FooterLogo";
import PhoneNumber from "@/views/partials/PhoneNumber";

export default {
  name: 'bottom-bar',
  data() {
    return {
      config: window.config,
    }
  },
  props: {
    menu: Array,
  },
  components: {PhoneNumber, FooterLogo, CorporateFooter}
}
</script>
